import React from 'react';
import { Navigate } from 'react-router';

import { LimitedPartnersDashboard } from 'packages/limitedPartners/ui/LimitedPartnersDashboard';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';

const RouteBase = () => {
  return <LimitedPartnersDashboard />;
};

export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/" />;
      }}
    >
      <RouteBase />
    </RouteErrorBoundary>
  );
};
